import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Users from 'components/Users/Users';
import NewDashboard from 'components/DashboardNew/Dashboard';
import { DashboardContainer } from 'containers/Dashboard/DashboardContainer';
import RoomSystemsContainer from 'containers/RoomSystems/RoomSystemsContainer';
import RoomSystemContainer from 'containers/RoomSystem/RoomSystemContainer';
import { SingleRecordingViewContainer } from '../Recordings/SingleRecording/SingleRecordingView';
import MeetingsContainer from 'containers/Meetings/MeetingsContainer';
import Recordings from 'components/Recordings/Recordings';
import { RECORDINGS_TABS } from 'constants/recordingsConstants';
import UsersVideosComp from 'components/Drilldowns/UsersAndVideo/UsersAndVideos';
import CallHistoryContainer from 'containers/Drilldowns/CallHistoryContainer';
import ConferenceDetails from 'components/Drilldowns/ConferenceDetails/ConferenceDetails';
import CallHistoryContainer2 from 'containers/Drilldowns/CallHistoryContainer2';
import LiveMeetingDetails from 'components/LiveMeetings/LiveMeetingDetails/LiveMeetingDetails';
import LiveStreamHistoryContainer from 'containers/Drilldowns/LiveStreamHistoryContainer';
import LiveStreamDetailsContainer from 'containers/Meetings/LiveStreamsTab/LiveStreamDetailsContainer';
import LiveStreamSummaryContainer from 'containers/Meetings/LiveStreamsTab/LiveStreamSummaryContainer';
import PastMeetingDetails from 'containers/PastMeetings/PastMeetingDetailsContainer';
import Settings from 'components/Settings/Settings';
import { Layout } from 'components/Layout/Layout';
import { hasAccess } from 'components/Can/canUtil';
import { PermissionTypes } from 'constants/permissionsConstants';
import { BASE_ROOM_SYSTEM_ROUTE } from 'constants/roomSystemConstants';
import { NEW_DASHBOARD, OLD_DASHBOARD } from 'constants/dashboard';
import LiveMeetingParticipantPage from 'components/LiveMeetings/LiveMeetingParticipantPage/LiveMeetingParticipantPage';
import {
  LIVE_MEETING_ROUTE,
  LIVE_MEETING_PARTICIPANT_ROUTE,
  LIVE_MEETING_PARTICIPANTS,
  LIVE_MEETING_GEO
} from 'constants/liveMeetings';
import {
  PAST_MEETING_GEO,
  PAST_MEETING_PARTICIPANT_ROUTE,
  PAST_MEETING_PARTICIPANTS,
  PAST_MEETING_ROUTE
} from 'constants/pastMeetings';
import PastMeetingParticipantPage from 'containers/PastMeetings/PastMeetingParticipantPageContainer';

// @ts-ignore
export const PrivateRoutes = (config) => {
  const { permissionsObject } = config;
  const hasSuperUserAccess = hasAccess([PermissionTypes.IS_SUPER_USER], permissionsObject || {});

  const publicURL = process.env.REACT_APP_BRANCH_NAME || undefined;

  if (hasSuperUserAccess) {
    return (
      <Router basename={publicURL}>
        <Switch>
          <Layout>
            <Route exact={true} path={'/'} component={NewDashboard}/>
            <Route path={'/users/:tab(users|group)'} component={Users}/>
            <Route path={'/meetings/:tab(meet|livestreams)'} component={MeetingsContainer}/>
            <Route exact={true} path={BASE_ROOM_SYSTEM_ROUTE} component={RoomSystemsContainer}/>
            <Route path={`${BASE_ROOM_SYSTEM_ROUTE}/:id/:tab(settings|controller|maintenance)?`} component={RoomSystemContainer}/>
            <Route path={'/drilldown/callhistory'} component={CallHistoryContainer}/>
            <Route path={'/drilldown/callhistory2'} component={CallHistoryContainer2}/>
            <Route path={'/drilldown/conferenceDetails'} component={ConferenceDetails}/>
            <Route path={`${LIVE_MEETING_ROUTE}/:id/(${LIVE_MEETING_PARTICIPANTS}|${LIVE_MEETING_GEO})?`} component={LiveMeetingDetails}/>
            <Route path={`${LIVE_MEETING_PARTICIPANT_ROUTE}/:id/:callId`} component={LiveMeetingParticipantPage}/>
            <Route path={`${PAST_MEETING_PARTICIPANT_ROUTE}/:id/:callId`} component={PastMeetingParticipantPage}/>
            <Route path={'/drilldown/usersVideos/:tab(users|rooms|users2|rooms2)/:id?'} component={UsersVideosComp}/>
            <Route path={`${PAST_MEETING_ROUTE}/:id/(${PAST_MEETING_PARTICIPANTS}|${PAST_MEETING_GEO})?`} component={PastMeetingDetails}/>
            {/* The expanded view of the dashboard live stream history*/}
            <Route exact={true} path={'/drilldown/livestream'} component={LiveStreamHistoryContainer} />
            {/* The history of a particular live stream (by name)*/}
            <Route exact={true} path={'/meetings/livestreamByName/:name/:meetingId?'} component={LiveStreamHistoryContainer}/>
            {/* The details of a particular live stream*/}
            <Route
              exact={true}
              path={'/meetings/livestream/:id/:tab(viewers|questions)'}
              component={LiveStreamDetailsContainer}
            />
            <Route
              exact={true}
              path={'/meetings/livestreamSummary/:id/:tab(viewers|questions)'}
              component={LiveStreamSummaryContainer}
            />
            <Route path={'/settings/:tab(group|icon|sso|details|downloads)?'} component={Settings}/>
            <Route path={'/recordings/:tab(recordingsFeed|myRecordings|watchListRecordings)?'} component={Recordings}/>
            <Route exact={true} path={'/singleRecording/:id'} component={SingleRecordingViewContainer}/>
            <Route exact={true} path={'/recordingsFeed'} render={() => (<Redirect to={RECORDINGS_TABS.RECORDINGS_FEED}/>)}/>
            <Route exact={true} path={'/myRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.MY_RECORDINGS}/>)}/>
            <Route exact={true} path={'/watchListRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.WATCHLIST}/>)}/>
            <Route path={NEW_DASHBOARD} component={NewDashboard}/>
            <Route path={OLD_DASHBOARD} component={DashboardContainer}/>
          </Layout>
        </Switch>
      </Router>
    );
  }

  const hasUserAccess = hasAccess([PermissionTypes.IS_USER], permissionsObject);

  if (hasUserAccess) {
    return (
      <Router basename={publicURL}>
        <Switch>
          <Layout>
            <Route exact={true} path={'/'} render={() => (<Redirect to="/recordingsFeed"/>)}/>
            <Route path={'/recordings/:tab(recordingsFeed|myRecordings|watchListRecordings)?'} component={Recordings}/>
            <Route exact={true} path={'/singleRecording/:id'} component={SingleRecordingViewContainer}/>
            <Route path={'/recordingsFeed'} render={() => (<Redirect to={RECORDINGS_TABS.RECORDINGS_FEED}/>)}/>
            <Route path={'/myRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.MY_RECORDINGS}/>)}/>
            <Route path={'/watchListRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.WATCHLIST}/>)}/>
          </Layout>
        </Switch>
      </Router>
    );
  }

  // Default
  return (
    <Router basename={publicURL}>
      <Switch>
        <Layout>
          <Route exact={true} path={'/'} render={() => (<Redirect to="/recordingsFeed"/>)}/>
          <Route path={'/recordings/:tab(recordingsFeed|myRecordings|watchListRecordings)?'} component={Recordings}/>
          <Route exact={true} path={'/singleRecording/:id'} component={SingleRecordingViewContainer}/>
          <Route path={'/recordingsFeed'} render={() => (<Redirect to={RECORDINGS_TABS.RECORDINGS_FEED}/>)}/>
          <Route path={'/myRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.MY_RECORDINGS}/>)}/>
          <Route path={'/watchListRecordings'} render={() => (<Redirect to={RECORDINGS_TABS.WATCHLIST}/>)}/>
        </Layout>
      </Switch>
    </Router>
  );

};
